module.exports = __webpack_public_path__ + "img/logo.41ede484.png";